<script setup lang="ts">
import type { PropType } from 'vue';

import { type SaleAssetBusListingItem } from '~/apiClient';

// COMPOSABLE
const { tt, td, formatUnits } = useTypedI18n();
const { getPlatformBusClassesLabel } = usePlatformBusClass();

// PROPS
const { asset } = defineProps({
    asset: { type: Object as PropType<SaleAssetBusListingItem>, required: true },
});

// DATA
const firstRegistration = computed(() => Date.parse(asset.firstRegistration));
</script>

<template>
    <SlpBaseCard>
        <template #header>
            <SlpCardImages :main-asset="asset" />
        </template>

        <template v-if="!!asset.class" #class> {{ getPlatformBusClassesLabel(asset.class) }} </template>

        <template #model>{{ asset.brand.brandValue }} {{ asset.model.modelValue }}</template>

        <template #registration>{{ td(firstRegistration, 'mmyyyyUTC') }}</template>

        <template #kilometer>{{ formatUnits.km(asset.km) }}</template>

        <template #euro-norm>{{ asset.euroNorm ? tt(`asset.euroNorm.${asset.euroNorm}`) : '-' }}</template>
    </SlpBaseCard>
</template>
